import React from "react";
import { Layout, Dropdown, Menu, Icon, Avatar } from "antd";

import { HOME_PAGE } from "src/common/constants";
import "./MsHeader.scss";
import logo from "./logo.png";

// 头部属性声明
interface PropsOwn {
  height?: number;
  picture?: string;
  name?: string;
  onLogout: () => void;
}

type AllProps = PropsOwn;

/**
 * 头部设置
 * 1、高度设置
 * @class MsHeader
 * @extends {React.Component}
 */
class MsHeader extends React.Component<AllProps> {
  // 登出
  public onLogout = () => {
    this.props.onLogout();
  }

  // 渲染
  public render() {
    return (
      <Layout.Header className="ms-header" style={ this.props.height ? { height: this.props.height, backgroundColor: "#fff" } : { backgroundColor: "#fff" } }>
        <a href={ HOME_PAGE }>
          <img src={ logo } className="logo" />
        </a>
        <Dropdown overlay={
          <Menu>
            <Menu.Item key="1">
              <a href="javascript:;" onClick={ this.onLogout }>退出</a>
            </Menu.Item>
          </Menu>
         } trigger={ ["click"] }>
          <div className="user-info">
            { this.props.name ? (this.props.name.length > 20 ? (this.props.name.substr(0, 19) + "...") : this.props.name) : "" }
            <Avatar size={ 30 } src={ this.props.picture } icon="user" style={ {margin: "0 7px"} } />
            <Icon type="down" />
          </div>
        </Dropdown>
      </Layout.Header>
    )
  }
}

export default MsHeader;



// WEBPACK FOOTER //
// ./src/components/ms-layout/ms-header/MsHeader.tsx